module.exports = __webpack_public_path__ + "img/ИФ-1(А)-037-m.eab34651.png";